'use client';

import { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';

export default function ToastProvider() {
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReducedMotion(mq.matches);
    const handler = (e: MediaQueryListEvent) => setReducedMotion(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return (
    <Toaster
      position="top-center"
      toastOptions={{
        duration: 4000,
        style: {
          background: '#fff',
          color: '#1f2937',
          border: '1px solid #e5e7eb',
          borderRadius: '0.75rem',
          padding: '12px 16px',
          fontSize: '14px',
          maxWidth: '420px',
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
          // Respect reduced-motion: skip slide animation
          ...(reducedMotion ? { transition: 'none' } : {}),
        },
        success: {
          iconTheme: { primary: '#16a34a', secondary: '#fff' },
          duration: 3000,
        },
        error: {
          iconTheme: { primary: '#dc2626', secondary: '#fff' },
          duration: 5000,
        },
      }}
    />
  );
}
